import type { FC, ReactNode } from 'react';
import { cx } from '@linaria/atomic';
import { Text } from '@frontend/design-system';
import { styles } from '../feature-promotion-banner.styles';

export interface FeaturePromotionBannerBodyProps {
  children: ReactNode;
  className?: string;
  testId?: string;
}

export const FeaturePromotionBannerBody: FC<FeaturePromotionBannerBodyProps> = ({ children, className, testId }) => {
  return (
    <section className={cx(styles.body, className)} data-testid={testId}>
      {children}
    </section>
  );
};

export interface FeaturePromotionBannerContentProps {
  children: ReactNode;
  fullWidth?: boolean;
  className?: string;
  testId?: string;
}

export const FeaturePromotionBannerContent: FC<FeaturePromotionBannerContentProps> = ({
  children,
  fullWidth = false,
  className,
  testId,
}) => {
  return (
    <div className={cx(styles.content, fullWidth && styles.contentFullWidth, className)} data-testid={testId}>
      {children}
    </div>
  );
};

export interface FeaturePromotionBannerTitleProps {
  children: ReactNode;
  as?: 'h2' | 'h3' | 'h4' | 'div' | 'p';
  className?: string;
  testId?: string;
}

export const FeaturePromotionBannerTitle: FC<FeaturePromotionBannerTitleProps> = ({
  children,
  as = 'div',
  className,
  testId,
}) => {
  return (
    <Text as={as} size='large' weight='bold' className={cx(styles.title, className)} data-testid={testId}>
      {children}
    </Text>
  );
};

export interface FeaturePromotionBannerDescriptionProps {
  children: ReactNode;
  as?: 'div' | 'p' | 'span';
  className?: string;
  testId?: string;
}

export const FeaturePromotionBannerDescription: FC<FeaturePromotionBannerDescriptionProps> = ({
  children,
  as = 'div',
  className,
  testId,
}) => {
  return (
    <Text as={as} size='medium' className={cx(styles.description, className)} data-testid={testId}>
      {children}
    </Text>
  );
};
